import { useEffect, useState } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { WHATSAPP_NUMBER } from "../data/chalets";

const NAV = [
    { href: "#inicio", label: "Início" },
    { href: "#chales", label: "Chalés" },
    { href: "#decoracao", label: "Decoração Romântica" },
    { href: "#contato", label: "Contato" },
];

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow] duration-300 ${
                scrolled
                    ? "bg-[#FDFBF7]/85 backdrop-blur-xl border-b border-[#1B4332]/10 shadow-sm"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
                <a href="#inicio" data-testid="header-logo" className="flex items-center gap-3">
                    <img
                        src="/images/logo.jpg"
                        alt="Rarity Chalés"
                        className="w-12 h-12 rounded-full object-cover border border-[#1B4332]/20"
                    />
                    <span
                        className={`text-lg font-bold tracking-tight transition-colors duration-300 ${
                            scrolled ? "text-[#1B231A]" : "text-white drop-shadow-lg"
                        }`}
                    >
                        Rarity Chalés
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
                    {NAV.map((item) => (
                        <a
                            key={item.href}
                            href={item.href}
                            data-testid={`nav-${item.href.replace("#", "")}`}
                            className={`text-sm font-bold tracking-wide transition-colors duration-300 hover:text-[#8B5A2B] ${
                                scrolled ? "text-[#3E4C3D]" : "text-white drop-shadow-lg"
                            }`}
                        >
                            {item.label}
                        </a>
                    ))}
                    <a
                        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Olá! Gostaria de informações sobre os chalés.")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="header-whatsapp-button"
                        className="flex items-center gap-2 bg-[#1B4332] hover:bg-[#2D6A4F] text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors duration-300"
                    >
                        <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
                        Reservar
                    </a>
                </nav>

                <button
                    data-testid="mobile-menu-button"
                    className={`md:hidden ${scrolled ? "text-[#1B231A]" : "text-white"}`}
                    onClick={() => setOpen(!open)}
                    aria-label="Menu"
                >
                    {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </div>

            {open && (
                <div className="md:hidden bg-[#FDFBF7] border-b border-[#1B4332]/10 px-6 py-6 space-y-4" data-testid="mobile-menu">
                    {NAV.map((item) => (
                        <a
                            key={item.href}
                            href={item.href}
                            onClick={() => setOpen(false)}
                            className="block text-base font-bold text-[#3E4C3D]"
                        >
                            {item.label}
                        </a>
                    ))}
                    <a
                        href={`https://wa.me/${WHATSAPP_NUMBER}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 bg-[#1B4332] text-white text-sm font-bold px-5 py-2.5 rounded-full"
                    >
                        <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
                        Reservar
                    </a>
                </div>
            )}
        </header>
    );
};
